<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <!-- <div class="flex_center_between_box">

                        <div style="display: flex;" class="font_size_12">

                        </div>
                        <div class="font1290C9 cuspoint textdecoration font20">
                            Add Company
                        </div>
                    </div> -->
          <div class="his_sel_box" style="width: 100%">
            <el-table
              ref="Usagelist"
              class="table_box table_height_30 table_font_size_14"
              @expand-change="handleExpandChange"
              :data="yourUsagelist"
              style="width: 100%"
              border
              :expand-row-keys="expands"
              row-key="id"
              empty-text="No Data"
            >
              <el-table-column type="expand" width="40">
                <template slot-scope="scope">
                  <div class="flex_center_bettwen PortFolioFilter">
                    <div class="flex_center_start">
                      <div class="cas_panel">
                        <el-date-picker
                          :append-to-body="true"
                          v-model="datePicker"
                          style="width: fit-content; max-width: 350px"
                          type="daterange"
                          range-separator=""
                          :start-placeholder="$t('DataManagement.StartingMonth')"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          :end-placeholder="$t('DataManagement.EndMonth')"
                        ></el-date-picker>
                      </div>
                      <div class="cas_panel margin-left10">
                        <el-input
                          type="text"
                          v-model="cascInptComapny"
                          clearable
                          :placeholder="$t('DataManagement.Entercompanyname')"
                        />
                      </div>
                      <div class="cas_panel margin-left10">
                        <el-select
                          style="width: 100%"
                          clearable
                          v-model="cascInptIndustry"
                          filterable
                          :popper-append-to-body="false"
                          popper-class="new-search-select"
                          :placeholder="$t('DataManagement.Selectindustry')"
                        >
                          <el-option
                            v-for="(item, index) in industryList"
                            :key="index"
                            :label="item.groupNameEn"
                            :value="item.groupNameEn"
                          >
                            <div class="flex-between-center">
                              <el-tooltip
                                effect="light"
                                :visible-arrow="false"
                                :disabled="item?.groupNameEn < 25"
                                :content="item.groupNameEn"
                                placement="right"
                              >
                                <span class="select-name">{{
                                  item.groupNameEn
                                }}</span>
                              </el-tooltip>
                            </div>
                          </el-option>
                        </el-select>
                      </div>
                      <div class="cas_panel margin-left10">
                        <el-select
                          style="width: 100%"
                          clearable
                          v-model="companyTypeCheckList"
                          filterable
                          :popper-append-to-body="false"
                          popper-class="new-search-select"
                          :placeholder="$t('DataManagement.Selectcompanytype')"
                        >
                          <el-option
                            v-for="(item, index) in companyTypeList"
                            :key="index"
                            :label="item.groupNameEn"
                            :value="item.groupNameEn"
                          >
                            <div class="flex-between-center">
                              <el-tooltip
                                effect="light"
                                :visible-arrow="false"
                                :disabled="item?.groupNameEn < 25"
                                :content="item.groupNameEn"
                                placement="right"
                              >
                                <span class="select-name">{{
                                  item.groupNameEn
                                }}</span>
                              </el-tooltip>
                            </div>
                          </el-option>
                        </el-select>
                      </div>
                      <div class="cas_panel margin-left10">
                        <el-select
                          style="width: 100%"
                          clearable
                          v-model="companyStatusCheckList"
                          filterable
                          :popper-append-to-body="false"
                          popper-class="new-search-select"
                          :placeholder="$t('DataManagement.Selectcompanystatus')"
                        >
                          <el-option
                            v-for="(item, index) in companyStatusList"
                            :key="index"
                            :label="item.groupNameEn"
                            :value="item.groupNameEn"
                          >
                            <div class="flex-between-center">
                              <el-tooltip
                                effect="light"
                                :visible-arrow="false"
                                :disabled="item?.groupNameEn < 25"
                                :content="item.groupNameEn"
                                placement="right"
                              >
                                <span class="select-name">{{
                                  item.groupNameEn
                                }}</span>
                              </el-tooltip>
                            </div>
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <el-button
                      style="
                        width: 120px !important;
                        min-width: auto !important;
                        height: 40px !important;
                        min-height: 40px !important;
                      "
                      class="btn_export margin-left10"
                      @click="PortifolioSearch"
                      >{{ $t("DataManagement.Search") }}</el-button
                    >
                  </div>
                  <div class="tree_table_box" style="padding-top: 0px">
                    <el-table
                      :data="PortfolioList"
                      border
                      cell-class-name=""
                      :key="scope.row.id"
                    >
                      <template slot="empty">No Data</template>
                      <el-table-column
                        prop="updateTime"
                        :label="$t('DataManagement.Date')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.updateTime
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="companyName"
                        width="300"
                        class-name="company company_link company_link_tooltip_normal"
                        :label="$t('DataManagement.CompanyName')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span
                            class="table-content company_link"
                            @click="setid(scope.row)"
                          >
                            {{ scope.row.companyName }}
                          </span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="Country"
                        :label="$t('DataManagement.Country')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.countryName
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="companyTypeEn"
                        :label="$t('DataManagement.CompanyType')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.companyTypeEn
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="companyStatusEn"
                        :label="$t('DataManagement.CompanyStatus')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.companyStatusEn
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="companyDqiEn"
                        :label="$t('DataManagement.DQI')"
                        align="left"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.companyDqiEn
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label=""
                        width="180"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div class="flex_center">
                            <el-popover
                              placement="left-star"
                              title=""
                              :disabled="isChangeProlio"
                              width="160"
                              trigger="click"
                              popper-class="ChangeProtliopopover"
                            >
                              <ul class="ChangeProtlio">
                                <el-checkbox-group v-model="checkList">
                                  <el-checkbox
                                    v-for="(item, index) in yourUsagelist"
                                    :key="index"
                                    :label="item.id"
                                    >{{ item.portfolioName }}</el-checkbox
                                  >
                                </el-checkbox-group>
                                <el-button
                                  style="
                                    height: 40px !important;
                                    min-height: 40px !important;
                                  "
                                  :class="
                                    checkList.length == 0
                                      ? ' btn_export btn_exporthui margin-bottom20'
                                      : 'btn_export margin-bottom20'
                                  "
                                  :disabled="checkList.length == 0"
                                  @click="ChangeProto(scope.row)"
                                  >{{ $t("DataManagement.Confirm") }}</el-button
                                >
                              </ul>

                              <svg
                                slot="reference"
                                t="1763451901009"
                                class="icon"
                                @click="isChangeProlio = false"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="15567"
                                width="28"
                                height="28"
                              >
                                <path
                                  d="M617.2672 722.944H185.4464c-59.136 0-107.264-53.248-107.264-118.7328V198.0928c0-65.4848 48.128-118.7328 107.52-118.7328h431.8208c59.136 0 107.2128 53.248 107.2128 118.7328V604.16c-0.256 65.536-48.3328 118.784-107.4688 118.784zM185.4464 125.44c-33.7408 0-61.184 32.6144-61.184 72.6528V604.16c0 40.0384 27.4432 72.6528 61.44 72.6528h431.8208c33.6896 0 61.1328-32.6144 61.1328-72.6528V198.0928c0-40.0384-27.4432-72.6528-61.1328-72.6528z"
                                  p-id="15568"
                                  fill="#1296db"
                                ></path>
                                <path
                                  d="M329.3696 650.24a22.9888 22.9888 0 0 1-23.04-23.04V418.3552c0-65.4848 48.128-118.784 107.52-118.784h206.336a23.04 23.04 0 0 1 0 46.08H413.5936c-33.7408 0-61.44 32.6144-61.44 72.704v209.0496a23.04 23.04 0 0 1-22.784 22.8352zM845.3632 943.1552H413.5936c-59.136 0-107.52-53.248-107.52-118.7328V768a23.04 23.04 0 0 1 46.08 0v56.32c0 40.0384 27.4432 72.6528 61.44 72.6528h431.7696c33.7408 0 61.184-32.6144 61.184-72.6528V418.3552c0-40.0896-27.4432-72.704-61.184-72.704h-62.3616a23.04 23.04 0 1 1 0-46.08h62.3616c59.136 0 107.264 53.2992 107.264 118.784V824.32c0 65.5872-48.128 118.8352-107.264 118.8352z"
                                  p-id="15569"
                                  fill="#1296db"
                                ></path>
                              </svg>
                            </el-popover>
                            <el-tooltip
                              class="tbl_opr_tip flex_center"
                              :visible-arrow="false"
                              effect="light"
                              :content="$t('DataManagement.Download')"
                              placement="top"
                            >
                              <svg
                                @click="Down(scope.row)"
                                t="1723022129119"
                                class="icon margin-left15"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6324"
                                width="28"
                                height="28"
                              >
                                <path
                                  d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                                  fill="#1296db"
                                  p-id="6325"
                                ></path>
                              </svg>
                            </el-tooltip>
                            <el-tooltip
                              class="tbl_opr_tip flex_center"
                              :visible-arrow="false"
                              effect="light"
                              :content="$t('DataManagement.Delete')"
                              placement="top"
                            >
                              <svg
                                t="1763435921214"
                                @click="deletePortfolioCompany(scope.row)"
                                class="icon margin-left15"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="8222"
                                width="32"
                                height="32"
                              >
                                <path
                                  d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                                  fill="#F56B6B"
                                  p-id="8223"
                                ></path>
                              </svg>
                            </el-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                      <template slot="empty">
                        <div>
                          <div>
                            <img
                              style="width: 50%; height: 50%"
                              src="../../../../assets/images/noDate.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </template>
                    </el-table>
                    <div class="page_i_box">
                      <Page
                        :totalFont="true"
                        :total="page.total"
                        :pageSize.sync="page.pageSize"
                        :currentPage="page.pageNo"
                        @onPageChange="onPageChangeList"
                      ></Page>

                      <div class="search_rsult_txt line_2">
                        {{ page.pageNo }}-{{ page.pageSize }} of over
                         <span class="foundOverNum" :style="{'color': $store.state.app.themeColor}">&nbsp;{{ page.total | FilterNum }}&nbsp;</span> results for "{{ $t("DataManagement.MyPortfolio") }}"
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="portfolioName"
                :label="$t('DataManagement.PortfolioName')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.portfolioName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="userName"
                :label="$t('DataManagement.User')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.userName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="groupTask"
                :label="$t('DataManagement.Task')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.groupTask }}</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="numberOfCompanies"
                :label="$t('DataManagement.NoofCompanies')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.numberOfCompanies
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop=""
                label=" "
                align="center"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div class="flex_center">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Edit')"
                      placement="top"
                    >
                      <svg
                        t="1718263375162"
                        @click="CustomDialog(scope.row)"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="11104"
                        width="2.85rem"
                        height="2.85rem"
                      >
                        <path
                          d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                          fill="#1296db"
                          p-id="11105"
                        ></path>
                      </svg>
                    </el-tooltip>
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Delete')"
                      placement="top"
                    >
                      <svg
                        t="1763435921214"
                        @click="deletePortfolioDetail(scope.row)"
                        class="icon margin-left20"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8222"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                          fill="#F56B6B"
                          p-id="8223"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <template slot="empty">
                <div>
                  <img
                    style="width: 50%; height: 50%"
                    src="../../../../assets/images/noDate.png"
                    alt=""
                  />
                </div>
              </template>
            </el-table>
            <!-- v-if="yourUsagelist.length > 0" -->

            <!-- <div v-if="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Custom
      :myDataMnegent="true"
      :showReport="showReportIndex"
      :CustomObj="CustomObj"
      @closeReportDialog="closeDialog3($event)"
    ></Custom>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getqueryPortfolio,
  getUserCompanyActionPage,
  downloadOnlinePdf,
} from "@/api/userApi";
import {
  deletePortfolio,
  changePortfolio,
  deleteCompanyFromPortfolio,
  getUserCompanyActionFilter,
} from "@/api/companyApi.js";
import Custom from "../../../../components/CustomPortfolio/Custom.vue";
import Page from "@/components/page/index.vue";
export default {
  mixins: [mixins1],
  components: {
    Page,
    Custom,
  },
  data() {
    return {
      reLoginVis: false,
      showReportIndex: false,
      menuActive: 1,
      datePicker: [],
      CategoryVal: "",
      yourUsagelist: [],
      isChangeProlio: true,
      window: window,
      currentExpandedRow: null,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      expands: [],
      token: localStorage.getItem("token"),
      IndicatorsOption: [],
      chinldsplicelist: [],
      splicelist: [],
      CustomObj: {
        groupTask: "",
        executorName: "",
        portfolioName: "",
        userName: "",
        id: "",
      },
      checkList: [],

      PortfolioList: [],
      datePicker: [],
      cascInptComapny: "",
      cascInptIndustry: "",
      industryList: [],
      companyTypeCheckList: "",
      companyTypeList: [],
      companyStatusList: [],
      companyStatusCheckList: "",
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    this.getgetUserActionLogPage();
  },

  methods: {
    // 过滤搜索
    PortifolioSearch() {
      this.getConditions();
      this.getPortfolioList();
    },
    //获取左边菜单
    async getConditions() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

      const params = {
        userId: userinfo.id,
        type: "4",
        portfolioId: this.currentExpandedRow.id,
        companyName: this.cascInptComapny,
        companyIsicEn: this.cascInptIndustry,
        companyTypeEn: this.companyTypeCheckList,
        companyStatusEn: this.companyStatusCheckList,
        startTime: this.datePicker == null ? "" : this.datePicker[0],
        endTime: this.datePicker == null ? "" : this.datePicker[1],
      };
      await getUserCompanyActionFilter(params).then((res) => {
        if (res && res.code) {
          this.industryList = res.data.industryList;

          this.companyTypeList = res.data.companyTypeList;

          this.companyStatusList = res.data.companyStatusList;
        } else {
        }
      });
    },
    // 公司切换组合
    ChangeProto(scope) {
      changePortfolio({
        portfolioIds: this.checkList,
        companyId: scope.id,
      }).then((res) => {
        if (res.code == 200) {
          this.isChangeProlio = true;
          this.getgetUserActionLogPage();
          this.getPortfolioList();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    // 获取公司列表
    getPortfolioList() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getUserCompanyActionPage({
        userId: userinfo.id,
        type: "4",
        portfolioId: this.currentExpandedRow.id,
        companyName: this.cascInptComapny,
        companyIsicEn: this.cascInptIndustry,
        companyTypeEn: this.companyTypeCheckList,
        companyStatusEn: this.companyStatusCheckList,
        startTime: this.datePicker == null ? "" : this.datePicker[0],
        endTime: this.datePicker == null ? "" : this.datePicker[1],
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.PortfolioList = res.data.rows;
            this.page.total = res.data.total;
          } else {
            this.PortfolioList = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 组合删除公司列表
    deletePortfolioCompany(scope) {
      deleteCompanyFromPortfolio({
        id: scope.id,
      }).then((res) => {
        if (res.code == 200) {
          this.getPortfolioList();
          this.getgetUserActionLogPage();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    // 删除组合
    deletePortfolioDetail(scope) {
      deletePortfolio({
        id: scope.id,
      }).then((res) => {
        if (res.code == 200) {
          this.getgetUserActionLogPage();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    CustomDialog(scope) {
      this.showReportIndex = true;

      this.CustomObj = scope;
    },
    // 关闭组合编辑
    closeDialog3(value) {
      this.getgetUserActionLogPage();
      this.showReportIndex = value;
    },
    // 全选事件
    handleSelectionChange(selection) {
      this.splicelist = [];
      selection.map((item) => {
        this.splicelist.push(item.id);
      });
    },
    // 展开行
    async handleExpandChange(row, expanded) {
      this.page.pageNo = 1;
      this.cascInptComapny = "";
      this.cascInptIndustry = "";
      this.companyTypeCheckList = "";
      this.companyStatusCheckList = "";
      this.datePicker = [];

      if (expanded) {
        this.checkList = [];
        if (this.expands.indexOf(row.id) < 0) {
          this.expands = [];
          this.expands.push(row.id);

          this.page.pageNo = 1;
          this.page.pageSize = 10;
          // 更新当前展开的行
          this.currentExpandedRow = row;
          this.getPortfolioList();
          this.getConditions();
        } else {
          this.expands = [];
        }
        if (this.currentExpandedRow !== row) {
        }
      } else {
        // 收起当前展开的行
        this.currentExpandedRow = null;
      }
    },
    // 子事件选中

    MenuClick(item) {
      this.menuActive = item.value;
    },
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaid +
          "/background/snapshot?id3a=" +
          row.aaaid +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    Down(scope) {
      downloadOnlinePdf(scope.aaaid).then((res) => {
        const binaryData = [];
        binaryData.push(res);
        let pdfUrl = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/pdf" }),
        );
        window.open(pdfUrl, "_blank");
      });
    },
    // 获取我的组合数据
    getgetUserActionLogPage() {
      getqueryPortfolio()
        .then((res) => {
          if (res.code == 200) {
            this.yourUsagelist = res.data;
          } else {
            this.yourUsagelist = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    onPageChangeList({ page, size }) {
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getPortfolioList();
    },
    currtentPageChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getPortfolioList();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold" !important;
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold" !important;
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
  width: max-content;
  margin: auto;
}

.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}

.menuActiveColor {
  background: #ffffff;
  border-radius: 4px;
}

.table_box /deep/ .el-table__expand-icon {
  display: block;
}

.ChangeProtlio {
}

/deep/ .ChangeProtliopopover {
  padding-bottom: 0px !important;
  left: -130px !important;
  top: -50px;
  max-height: 230px;
  overflow-y: auto;
  width: fit-content !important;
}

.el-checkbox {
  display: block;
  margin-bottom: 15px;
}

/deep/ .el-table,
/deep/ .el-table__body-wrapper {
  overflow: visible;
}

.tree_table_box {
  padding-bottom: 0px;
}

.PortFolioFilter {
  padding: 15px;
}

@media screen and (max-width: 1920px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
  .Addcompanies{
    margin-bottom: 10px;
  }
  ::v-deep .el-table td.el-table__cell {
      height: 50px !important;
  }
  ::v-deep .el-table th.el-table__cell > .cell {
    padding-left: 15px;
    padding-right: 15px;
  } 
}

@media screen and (max-width: 1439px) {
  .btn_blue {
    font-size: 12px;
    width: max-content;
  }
  .Addcompanies{
  margin-bottom: 10px;
}
} 
</style>
